import './Top.css';
import img from '../../../resources/Group 1000003425.png'
import apple from '../../../resources/apple.png'
import dish_1 from '../../../resources/1660_1745608929597.png'
import dish_2 from '../../../resources/1752_1745625478034.png'
import dish_3 from '../../../resources/1694_1745612923596.png'
import dish_4 from '../../../resources/1904_1745644714436.png'
import dish_5 from '../../../resources/1400_1745615808224.png'
import dish_6 from '../../../resources/1965_1746487221915.png'
import dish_7 from '../../../resources/1887_1745644424344.png'
import dish_8 from '../../../resources/1975_1746490583775.png'
import dish_9 from '../../../resources/1688_1745613274157.png'
import dish_10 from '../../../resources/2002_1746492337461.png'
import dish_11 from '../../../resources/1380_1745614687542.png'
import dish_12 from '../../../resources/1746_1745625512887.png'
import dish_13 from '../../../resources/1981_1746490541716.png'
import dish_14 from '../../../resources/1791_1745625098716.png'
import dish_15 from '../../../resources/1755_1745626072881.png'
import calories from '../../../resources/calories.png'
import protein from '../../../resources/protein.png'
import { useEffect, useState } from 'react';
import Carousel from '../../../components/Carousel/Carousel';

function Top() {
    const [meals, setMeals] = useState([])

    async function getMeals() {
        const width = window.innerWidth
        let comp_in_div
        const tmp_array = []
        tmp_array.push(
            <div className='top_indiv_meal_div gray_gradient cursor_default'>
                <img src={dish_1} className='top_indiv_meal_img' />
                <p className='text_align_center font_size_16 font_weight_500'>Bistecca alla Fiorentina                </p>
                <div className='flex align_center gap_20'>
                    <div className='flex gap_6 align_center'>
                        <img src={calories} className='top_indiv_meal_icon' />
                        <p className='gray_scale_1'>1,100</p>
                    </div>
                    <div className='flex gap_6 align_center'>
                        <img src={protein} className='top_indiv_meal_icon' />
                        <p className='gray_scale_1'>90g</p>
                    </div>
                </div>
            </div>)
        tmp_array.push(
            <div className='top_indiv_meal_div gray_gradient cursor_default'>
                <img src={dish_2} className='top_indiv_meal_img' />
                <p className='text_align_center font_size_16 font_weight_500'>Caesar Salad                </p>
                <div className='flex align_center gap_20'>
                    <div className='flex gap_6 align_center'>
                        <img src={calories} className='top_indiv_meal_icon' />
                        <p className='gray_scale_1'>300</p>
                    </div>
                    <div className='flex gap_6 align_center'>
                        <img src={protein} className='top_indiv_meal_icon' />
                        <p className='gray_scale_1'>6g</p>
                    </div>
                </div>
            </div>)
        tmp_array.push(
            <div className='top_indiv_meal_div gray_gradient cursor_default'>
                <img src={dish_3} className='top_indiv_meal_img' />
                <p className='text_align_center font_size_16 font_weight_500'>Biryani</p>
                <div className='flex align_center gap_20'>
                    <div className='flex gap_6 align_center'>
                        <img src={calories} className='top_indiv_meal_icon' />
                        <p className='gray_scale_1'>930</p>
                    </div>
                    <div className='flex gap_6 align_center'>
                        <img src={protein} className='top_indiv_meal_icon' />
                        <p className='gray_scale_1'>70g</p>
                    </div>
                </div>
            </div>)
        tmp_array.push(
            <div className='top_indiv_meal_div gray_gradient cursor_default'>
                <img src={dish_4} className='top_indiv_meal_img' />
                <p className='text_align_center font_size_16 font_weight_500'>Kung Pao Beef</p>
                <div className='flex align_center gap_20'>
                    <div className='flex gap_6 align_center'>
                        <img src={calories} className='top_indiv_meal_icon' />
                        <p className='gray_scale_1'>400</p>
                    </div>
                    <div className='flex gap_6 align_center'>
                        <img src={protein} className='top_indiv_meal_icon' />
                        <p className='gray_scale_1'>34g</p>
                    </div>
                </div>
            </div>)
        tmp_array.push(
            <div className='top_indiv_meal_div gray_gradient cursor_default'>
                <img src={dish_5} className='top_indiv_meal_img' />
                <p className='text_align_center font_size_16 font_weight_500'>Kabab Koobideh</p>
                <div className='flex align_center gap_20'>
                    <div className='flex gap_6 align_center'>
                        <img src={calories} className='top_indiv_meal_icon' />
                        <p className='gray_scale_1'>312</p>
                    </div>
                    <div className='flex gap_6 align_center'>
                        <img src={protein} className='top_indiv_meal_icon' />
                        <p className='gray_scale_1'>24g</p>
                    </div>
                </div>
            </div>)
        tmp_array.push(
            <div className='top_indiv_meal_div gray_gradient cursor_default'>
                <img src={dish_6} className='top_indiv_meal_img' />
                <p className='text_align_center font_size_16 font_weight_500'>Matcha Green Tea</p>
                <div className='flex align_center gap_20'>
                    <div className='flex gap_6 align_center'>
                        <img src={calories} className='top_indiv_meal_icon' />
                        <p className='gray_scale_1'>3</p>
                    </div>
                    <div className='flex gap_6 align_center'>
                        <img src={protein} className='top_indiv_meal_icon' />
                        <p className='gray_scale_1'>0.3g</p>
                    </div>
                </div>
            </div>)
        tmp_array.push(
            <div className='top_indiv_meal_div gray_gradient cursor_default'>
                <img src={dish_7} className='top_indiv_meal_img' />
                <p className='text_align_center font_size_16 font_weight_500'>Dumplings</p>
                <div className='flex align_center gap_20'>
                    <div className='flex gap_6 align_center'>
                        <img src={calories} className='top_indiv_meal_icon' />
                        <p className='gray_scale_1'>60</p>
                    </div>
                    <div className='flex gap_6 align_center'>
                        <img src={protein} className='top_indiv_meal_icon' />
                        <p className='gray_scale_1'>3g</p>
                    </div>
                </div>
            </div>)
        tmp_array.push(
            <div className='top_indiv_meal_div gray_gradient cursor_default'>
                <img src={dish_8} className='top_indiv_meal_img' />
                <p className='text_align_center font_size_16 font_weight_500'>Crêpe</p>
                <div className='flex align_center gap_20'>
                    <div className='flex gap_6 align_center'>
                        <img src={calories} className='top_indiv_meal_icon' />
                        <p className='gray_scale_1'>155</p>
                    </div>
                    <div className='flex gap_6 align_center'>
                        <img src={protein} className='top_indiv_meal_icon' />
                        <p className='gray_scale_1'>4g</p>
                    </div>
                </div>
            </div>)
        tmp_array.push(
            <div className='top_indiv_meal_div gray_gradient cursor_default'>
                <img src={dish_9} className='top_indiv_meal_img' />
                <p className='text_align_center font_size_16 font_weight_500'>Butter Chicken</p>
                <div className='flex align_center gap_20'>
                    <div className='flex gap_6 align_center'>
                        <img src={calories} className='top_indiv_meal_icon' />
                        <p className='gray_scale_1'>900</p>
                    </div>
                    <div className='flex gap_6 align_center'>
                        <img src={protein} className='top_indiv_meal_icon' />
                        <p className='gray_scale_1'>29g</p>
                    </div>
                </div>
            </div>)
        tmp_array.push(
            <div className='top_indiv_meal_div gray_gradient cursor_default'>
                <img src={dish_10} className='top_indiv_meal_img' />
                <p className='text_align_center font_size_16 font_weight_500'>Açaí na Tigela</p>
                <div className='flex align_center gap_20'>
                    <div className='flex gap_6 align_center'>
                        <img src={calories} className='top_indiv_meal_icon' />
                        <p className='gray_scale_1'>200</p>
                    </div>
                    <div className='flex gap_6 align_center'>
                        <img src={protein} className='top_indiv_meal_icon' />
                        <p className='gray_scale_1'>4g</p>
                    </div>
                </div>
            </div>)
        tmp_array.push(
            <div className='top_indiv_meal_div gray_gradient cursor_default'>
                <img src={dish_11} className='top_indiv_meal_img' />
                <p className='text_align_center font_size_16 font_weight_500'>Ash Reshteh</p>
                <div className='flex align_center gap_20'>
                    <div className='flex gap_6 align_center'>
                        <img src={calories} className='top_indiv_meal_icon' />
                        <p className='gray_scale_1'>170</p>
                    </div>
                    <div className='flex gap_6 align_center'>
                        <img src={protein} className='top_indiv_meal_icon' />
                        <p className='gray_scale_1'>8g</p>
                    </div>
                </div>
            </div>)
        tmp_array.push(
            <div className='top_indiv_meal_div gray_gradient cursor_default'>
                <img src={dish_12} className='top_indiv_meal_img' />
                <p className='text_align_center font_size_16 font_weight_500'>Cheeseburger</p>
                <div className='flex align_center gap_20'>
                    <div className='flex gap_6 align_center'>
                        <img src={calories} className='top_indiv_meal_icon' />
                        <p className='gray_scale_1'>580</p>
                    </div>
                    <div className='flex gap_6 align_center'>
                        <img src={protein} className='top_indiv_meal_icon' />
                        <p className='gray_scale_1'>32g</p>
                    </div>
                </div>
            </div>)
        tmp_array.push(
            <div className='top_indiv_meal_div gray_gradient cursor_default'>
                <img src={dish_13} className='top_indiv_meal_img' />
                <p className='text_align_center font_size_16 font_weight_500'>Crème Brûlée</p>
                <div className='flex align_center gap_20'>
                    <div className='flex gap_6 align_center'>
                        <img src={calories} className='top_indiv_meal_icon' />
                        <p className='gray_scale_1'>520</p>
                    </div>
                    <div className='flex gap_6 align_center'>
                        <img src={protein} className='top_indiv_meal_icon' />
                        <p className='gray_scale_1'>5g</p>
                    </div>
                </div>
            </div>)
        tmp_array.push(
            <div className='top_indiv_meal_div gray_gradient cursor_default'>
                <img src={dish_14} className='top_indiv_meal_img' />
                <p className='text_align_center font_size_16 font_weight_500'>Bagel with Cream Cheese</p>
                <div className='flex align_center gap_20'>
                    <div className='flex gap_6 align_center'>
                        <img src={calories} className='top_indiv_meal_icon' />
                        <p className='gray_scale_1'>345</p>
                    </div>
                    <div className='flex gap_6 align_center'>
                        <img src={protein} className='top_indiv_meal_icon' />
                        <p className='gray_scale_1'>11g</p>
                    </div>
                </div>
            </div>)
        tmp_array.push(
            <div className='top_indiv_meal_div gray_gradient cursor_default'>
                <img src={dish_15} className='top_indiv_meal_img' />
                <p className='text_align_center font_size_16 font_weight_500'>French Toast</p>
                <div className='flex align_center gap_20'>
                    <div className='flex gap_6 align_center'>
                        <img src={calories} className='top_indiv_meal_icon' />
                        <p className='gray_scale_1'>450</p>
                    </div>
                    <div className='flex gap_6 align_center'>
                        <img src={protein} className='top_indiv_meal_icon' />
                        <p className='gray_scale_1'>13g</p>
                    </div>
                </div>
            </div>)

        if (width < 518)
            comp_in_div = 1
        else if (width <= 830)
            comp_in_div = 2
        else if (width <= 1000)
            comp_in_div = 3
        else if (width <= 1200)
            comp_in_div = 3
        else if (width <= 1366)
            comp_in_div = 3
        else if (width < 2130)
            comp_in_div = 3
        else comp_in_div = 4

        const result = []
        tmp_array.map((data_tmp, i) => {
            if (i % comp_in_div === 0)
                result.push(
                    <div key={i} className='top_indiv_meal_list_div'>
                        {tmp_array.map((data, j) => {
                            if (j >= i && j < (i + comp_in_div))
                                return data
                        })}
                    </div>
                )
        });

        setMeals(result)
    }
    const handleResize = () => {
        getMeals()
    };

    useEffect(() => {
        getMeals()

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div className='top_main_div'>
            {/* AI Background Animations */}
            <div className='ai-background'>
                <div className='ai-grid'></div>
                <div className='holographic-effect'></div>
                <div className='ai-particle'></div>
                <div className='ai-particle'></div>
                <div className='ai-particle'></div>
                <div className='ai-particle'></div>
                <div className='ai-particle'></div>
                <div className='ai-particle'></div>
                <div className='ai-particle'></div>
                <div className='ai-particle'></div>
                <div className='ai-particle'></div>
                <div className='ai-particle'></div>
                <div className='neural-connection'></div>
                <div className='neural-connection'></div>
                <div className='neural-connection'></div>
                <div className='neural-connection'></div>
                <div className='neural-connection'></div>
                <div className='neural-connection'></div>
                <div className='data-circle'></div>
                <div className='data-circle'></div>
                <div className='data-circle'></div>
                <div className='data-circle'></div>
                <div className='data-circle'></div>
                <div className='quantum-dot'></div>
                <div className='quantum-dot'></div>
                <div className='quantum-dot'></div>
                <div className='quantum-dot'></div>
                <div className='quantum-dot'></div>
            </div>

            <div className='top_left_div'>

                <h1 className='green_gradient_p_animated'>PrepWize</h1>
                <h3 className=''>Effortless <span className='green_gradient_p_animated'>Calorie Tracking</span> for Better Health</h3>
                <p className='top_coming_soon_p font_size_18 gray_scale_2'>PrepWize available on iOS</p>
                <div className='top_app_buttons_container'>
                    <a href="https://apps.apple.com/us/app/prepwize-ai-meal-planner/id6744729394" target="_blank" rel="noopener noreferrer" className='mobile_app_button_div'>
                        <img src={apple} />
                        <p className='font_size_18 white'>App Store</p>
                    </a>
                </div>
                <h3 className='gray_scale_2 font_size_20'>Discover delicious recipes and effortless calorie tracking. Enjoy healthier eating with full nutrition details and simple cooking steps.</h3>

                <div className='top_all_meal_carousel_div top_meals_desktop_only'>
                    <Carousel array={meals} hide_index />
                </div>
            </div>


        </div >
    );
}

export default Top;
